import { Row } from '@tanstack/react-table';
import { ReactNode } from 'react';

import { ChevronDown, ChevronUp } from '../../../icons';
import classes from '../ConfigurableTable.module.scss';

interface ExpandToggleProps<T> {
    /** A valid ReactNode */
    children?: ReactNode;
    /** Row object from Tanstack Table */
    row: Row<T>;
}

export default function ExpandableRowToggle<T>({ children, row }: ExpandToggleProps<T>) {
    const Icon = row.getIsExpanded() ? ChevronUp : ChevronDown;

    return (
        <div
            className={classes['nested-row']}
            style={{
                paddingLeft: `${row.depth * 2}rem`,
            }}
        >
            {children}
            {row.getCanExpand() ? (
                <button
                    aria-label={row.getIsExpanded() ? 'Collapse Row' : 'Expand Row'}
                    className={classes['expand-toggle']}
                    onClick={row.getToggleExpandedHandler()}
                    type="button"
                >
                    <Icon aria-hidden height={8} width={14} />
                </button>
            ) : null}
        </div>
    );
}
